var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Header } from '../util/headers';
/**
 * Creates a new validateStatus function that will use the one already used and also
 * accept status code 304.
 */
export function createValidateStatus(oldValidate) {
    return oldValidate
        ? function (status) { return oldValidate(status) || status === 304; }
        : function (status) { return (status >= 200 && status < 300) || status === 304; };
}
/** Checks if the given method is in the methods array */
export function isMethodIn(requestMethod, methodList) {
    var e_1, _a;
    if (methodList === void 0) { methodList = []; }
    requestMethod = requestMethod.toLowerCase();
    try {
        for (var methodList_1 = __values(methodList), methodList_1_1 = methodList_1.next(); !methodList_1_1.done; methodList_1_1 = methodList_1.next()) {
            var method = methodList_1_1.value;
            if (method.toLowerCase() === requestMethod) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (methodList_1_1 && !methodList_1_1.done && (_a = methodList_1.return)) _a.call(methodList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
export function setRevalidationHeaders(cache, config) {
    var _a;
    config.headers || (config.headers = {});
    var _b = config.cache, etag = _b.etag, modifiedSince = _b.modifiedSince;
    if (etag) {
        var etagValue = etag === true ? (_a = cache.data) === null || _a === void 0 ? void 0 : _a.headers[Header.ETag] : etag;
        if (etagValue) {
            config.headers[Header.IfNoneMatch] = etagValue;
        }
    }
    if (modifiedSince) {
        config.headers[Header.IfModifiedSince] =
            modifiedSince === true
                ? // If last-modified is not present, use the createdAt timestamp
                    cache.data.headers[Header.LastModified] ||
                        new Date(cache.createdAt).toUTCString()
                : modifiedSince.toUTCString();
    }
}
/**
 * Creates the new date to the cache by the provided response. Also handles possible 304
 * Not Modified by updating response properties.
 */
export function setupCacheData(response, cache) {
    if (response.status === 304 && cache) {
        // Set the cache information into the response object
        response.cached = true;
        response.data = cache.data;
        response.status = cache.status;
        response.statusText = cache.statusText;
        // Update possible new headers
        response.headers = __assign(__assign({}, cache.headers), response.headers);
        // return the old cache
        return cache;
    }
    // New Response
    return {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    };
}
